var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeartSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2305 1.59912C10.834 0.431152 8.77734 0.608887 7.48242 1.95459L7 2.4624L6.49219 1.95459C5.45117 0.888184 3.36914 0.228027 1.74414 1.59912C0.144531 2.97021 0.0683594 5.40771 1.49023 6.88037L6.41602 11.9585C6.56836 12.1108 6.77148 12.187 6.97461 12.187C7.20312 12.187 7.40625 12.1108 7.55859 11.9585L12.4844 6.88037C13.9062 5.40771 13.8301 2.97021 12.2305 1.59912ZM11.9004 6.32178L7 11.3999L2.07422 6.32178C1.10938 5.30615 0.90625 3.40186 2.27734 2.23389C3.67383 1.04053 5.29883 1.90381 5.9082 2.51318L7 3.63037L8.06641 2.51318C8.65039 1.90381 10.3008 1.04053 11.6973 2.23389C13.0684 3.40186 12.8652 5.30615 11.9004 6.32178Z",
    fill: "#D9A81B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartSmall);
export default __webpack_public_path__ + "static/media/heart-small.2496239b.svg";
export { ForwardRef as ReactComponent };